import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Refetches everything an account action changes: the user, their login
 * history, nursery member lists, the People directory and their People Hub
 * profile.
 */
export function useInvalidateAccount() {
  const queryClient = useQueryClient();

  return useCallback(
    (userIds: string | readonly string[]) => {
      const profileKeys = (
        typeof userIds === "string" ? [userIds] : userIds
      ).map((userId) => `/people/${userId}`);
      return queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0];
          if (typeof key !== "string") return false;
          return (
            key.startsWith("/v1/users") ||
            key.includes("/members") ||
            key.endsWith("/people") ||
            profileKeys.some((profileKey) => key.includes(profileKey))
          );
        },
        refetchType: "all",
      });
    },
    [queryClient],
  );
}
